export const AS_BUSINESS_UNIT_TYPE = 2
